import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { getAffiliateCreditTransactions } from '../../actions';
import {
  AffiliateCreditTransactionItem,
  GetAffiliateCreditTransactionsResponse,
  PaginationInfo
} from '../../lib/types';

interface UseAffiliateCreditTransactionsProps {
  pageNumber?: number;
  perPage?: number;
}

const useAffiliateCreditTransactions = ({
  pageNumber = 1,
  perPage = 10
}: UseAffiliateCreditTransactionsProps) => {
  const queryParams = useMemo(() => {
    const params: Record<string, string | number> = {
      pageNumber,
      perPage
    };

    return params;
  }, [pageNumber, perPage]);

  const { data, isLoading, refetch } = useQuery<unknown, Error, GetAffiliateCreditTransactionsResponse>(
    ['/affiliate/v2/portal/affiliate-credit-transactions', queryParams],
    async () => {
      const response = await getAffiliateCreditTransactions(queryParams);
      return response;
    },
    {
      suspense: false,
      keepPreviousData: true
    }
  );

  const transactions: AffiliateCreditTransactionItem[] = useMemo(() => {
    const responseData = (data as GetAffiliateCreditTransactionsResponse)?.body || (data as unknown as { data: AffiliateCreditTransactionItem[]; pagination: PaginationInfo });
    return responseData?.data || [];
  }, [data]);

  const pagination: PaginationInfo | null = useMemo(() => {
    const responseData = (data as GetAffiliateCreditTransactionsResponse)?.body || (data as unknown as { data: AffiliateCreditTransactionItem[]; pagination: PaginationInfo });
    return responseData?.pagination || null;
  }, [data]);

  return {
    transactions,
    pagination,
    transactionsLoading: isLoading,
    refetchTransactions: refetch
  };
};

export default useAffiliateCreditTransactions;

